<script>
import feather from 'feather-icons';
import FooterCopyright from './FooterCopyright.vue';
import { socialLinks } from '../../data/socialLinks';

export default {
	components: { FooterCopyright },
	data() {
		return {
			socials: socialLinks,
		};
	},
	mounted() {
		feather.replace();
	},
	updated() {
		feather.replace();
	},
};
</script>

<template>
	<div class="container mx-auto">
		<div
			class="pt-20 sm:pt-30 pb-8 mt-20 border-t-2 border-primary-light dark:border-secondary-dark"
		>
			<!-- Footer social links -->
			<div
				class="flex flex-col justify-center items-center mb-12 sm:mb-20"
			>
				<p
					class="font-general-semibold text-3xl sm:text-4xl font-semibold text-primary-dark dark:text-primary-light mb-5"
				>
          合作联系
				</p>
        <ul class="flex flex-col md:flex-row items-center md:justify-center gap-6 md:gap-12 text-ternary-dark dark:text-ternary-light text-center md:text-left">
          <li class="flex flex-col items-center md:items-start">
            <span class="text-sm opacity-70 mb-1">合作致电</span>
            <span class="font-medium">13901472491（王经理）</span>
          </li>

          <div class="hidden md:block w-px h-8 bg-gray-300 dark:bg-gray-700"></div>

          <li class="flex flex-col items-center md:items-start">
            <span class="text-sm opacity-70 mb-1">合作邮箱</span>
            <span class="font-medium">wjj@rjzt.net</span>
          </li>

          <div class="hidden md:block w-px h-8 bg-gray-300 dark:bg-gray-700"></div>

          <li class="flex flex-col items-center md:items-start">
            <span class="text-sm opacity-70 mb-1">公司地址</span>
            <span class="font-medium">江苏省南通市如东县掘港镇陈高工业园66号</span>
          </li>
        </ul>
			</div>

			<!-- Footer copyright -->
			<FooterCopyright />
		</div>
	</div>
</template>

<style scoped></style>
